import React from 'react'
import { Card, CardContent, Stack, Typography } from '@mui/material'

const CandidateDetailSection = ({ icon, title, children }) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Stack direction='row' spacing={1} alignItems='center' sx={{ mb: 2 }}>
          {icon}
          <Typography variant='h6' fontWeight={600}>
            {title}
          </Typography>
        </Stack>
        {children}
      </CardContent>
    </Card>
  )
}

export default CandidateDetailSection
